import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q4s7hypqdn: FaireBrandEntity = {
  token: "b_q4s7hypqdn",
  type: "brand",
  name: "Little Dick's Sauces",
  avatarUrl:
    "https://cdn.faire.com/fastly/95c8d2d9116f82fae528b18cd473c7813d5a6eb0a1a018c54f269bf73bd3d2cc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9220b2f04d4cde9764dd95d6ba9b78a288f61414857cdade7d93c52732864df1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/95c8d2d9116f82fae528b18cd473c7813d5a6eb0a1a018c54f269bf73bd3d2cc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9220b2f04d4cde9764dd95d6ba9b78a288f61414857cdade7d93c52732864df1.jpeg",
  location: "Long Island City, NY, USA",
  minimumOrderDollars: 60,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "Born in NYC. Featured on Hot Ones. Loved Everywhere.\n\nAt Little Dick’s, we craft bold, small-batch hot sauces that bring BIG flavor without overpowering your food. Every bottle is made with all-natural ingredients and perfectly balanced heat—designed to elevate your favorite dishes, not bury them in spice.\n\nOur lineup features five unique flavors, each created by founders Jackie and Rich (“Little Dick” himself). From sweet-and-smoky to tropical and fiery, every sauce has its own personality and spice level—so there’s something for every palate.\n\nAll of our sauces are:\n🌱 100% natural\n🌾 Gluten-free\n🥛 Dairy-free\n🥦 Vegan-friendly\n🚫 MSG-free\nProudly made in the USA\n\nMost importantly? They taste incredible.\n\nTry Little Dick’s today—because BIG things really do come in small packages. 😉",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:46.736Z",
    importedBy: "entity-db-cli",
  },
};
